import { render } from "./Footer.vue?vue&type=template&id=3a92ebec&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=3a92ebec&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a92ebec"]])

export default __exports__